var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.316,
    height: 17.492,
    viewBox: "0 0 18.316 17.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4594",
    "data-name": "Group 4594",
    transform: "translate(-137.815 -1598.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M405.186,294.382v6.474a.289.289,0,0,1-.29.29h-3.342a.29.29,0,0,1-.29-.29v-6.021c0-1.585-.566-2.666-1.986-2.666a2.145,2.145,0,0,0-2.011,1.434,2.673,2.673,0,0,0-.13.956v6.3a.29.29,0,0,1-.29.29h-3.341a.289.289,0,0,1-.29-.29c.008-1.6.041-9.383.007-11.212a.288.288,0,0,1,.29-.293h3.335a.29.29,0,0,1,.29.29v1.382c-.008.013-.019.026-.026.039h.026v-.039a3.9,3.9,0,0,1,3.534-1.949c2.58,0,4.514,1.686,4.514,5.308Zm-17.77,6.763h3.342a.289.289,0,0,0,.29-.29V289.641a.29.29,0,0,0-.29-.29h-3.342a.29.29,0,0,0-.29.29v11.215A.289.289,0,0,0,387.416,301.145Z",
    transform: "translate(-249.055 1314.821)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 2.099,
    cy: 2.099,
    r: 2.099,
    transform: "translate(137.815 1598.474)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedin-white.a9c0ef7122d336fe4843789b45058d42.svg";
export { ForwardRef as ReactComponent };